import { ProductForm as ProductFormType } from '../../../redux/types/products'
import { PRODUCT_SUBTYPE_OPTIONS } from '../../../consts'
import { ProductType } from '../../../types'

export const validate = (values: ProductFormType) => {
  const errors: any = {}

  if (!values.name) {
    errors.name = 'Name is required'
  }

  if (!values.description) {
    errors.description = 'Description is required'
  }

  if (!values.kind) {
    errors.kind = 'Product type is required'
  }

  if (values.kind === 'flower' && !values.category) {
    errors.category = 'Lineage is required on Flower type'
  }

  if (values.kind === 'flower' && !values.root_subtype) {
    errors.root_subtype = 'Subtype is required on Flower type; use Flower/Flower'
  }

  const subtypeValues =
    PRODUCT_SUBTYPE_OPTIONS[values?.kind as ProductType]?.map((option) => option.value) || []

  if (!!values.root_subtype && !subtypeValues.includes(values.root_subtype)) {
    errors.root_subtype = `${values.root_subtype} is not a standard subcategory`
  }

  return errors
}
